import { useState } from 'react'
import { Link, NavLink, useNavigate } from 'react-router-dom'
import { useBag } from '../store'

export function Header() {
  const { count } = useBag()
  const [open, setOpen] = useState(false)
  const [q, setQ] = useState('')
  const nav = useNavigate()
  const links = [
    { to: '/women', label: 'Women', id: 'nav-women' },
    { to: '/men', label: 'Men', id: 'nav-men' },
    { to: '/new', label: 'New', id: 'nav-new' },
    { to: '/sale', label: 'Sale', id: 'nav-sale' },
  ]
  return (
    <>
      <div className="announce">Free shipping on orders over $75 · Easy 30-day returns</div>
      <header className="header">
        <div className="container row">
          <button className="burger" aria-label="Menu" onClick={() => setOpen(o => !o)}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="M4 7h16M4 12h16M4 17h16"/></svg>
          </button>
          <nav className={'nav' + (open ? ' open' : '')} aria-label="Primary">
            {links.map(l => (
              <NavLink key={l.to} to={l.to} data-testid={l.id} onClick={() => setOpen(false)}>{l.label}</NavLink>
            ))}
          </nav>
          <Link to="/" className="wordmark" aria-label="Ensemble home">Ensemble</Link>
          <div className="tools">
            <form className="search" role="search" onSubmit={e => { e.preventDefault(); if (q.trim()) { nav('/search?q=' + encodeURIComponent(q.trim())); setQ('') } }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>
              <input aria-label="Search" placeholder="Search" value={q} onChange={e => setQ(e.target.value)} />
            </form>
            <Link to="/account" aria-label="Account">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 3.6-7 8-7s8 3 8 7"/></svg>
            </Link>
            <Link to="/bag" className="bag-link" data-testid="bag-link" aria-label={`Bag, ${count} items`}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="M6 8h12l1 13H5L6 8Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>
              <span className="bag-count" data-testid="bag-count">{count}</span>
            </Link>
          </div>
        </div>
      </header>
    </>
  )
}
